import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, props ) => ( {
	categoryPostLayout: {
		display             : "grid",
		gridTemplateColumns : props?.deviceMobileView ? "1fr" : props?.deviceViewTab ? "1fr 1fr" : " 1fr 1fr 1fr",
		gridGap             : "20px"
	}
} ) );
